var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"coursesystem-container"},[_c('module1'),_c('module2',{ref:"course2"}),_c('module3',{ref:"course3"}),_c('module4',{ref:"course4"}),_c('module5',{ref:"course5"}),_c('module6',{ref:"course6"}),_c('module7',{ref:"course7"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }